import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { carImageUrl } from '../Config/Config';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import Geocode from "react-geocode";
/* 
import {GET_EDITUSER,GET_USERDETAILLIST  }  from '../../actions';  */
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Edit extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		super(props);	
	    const userid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

		this.state = {
			userid: userid,
			username:'',
			firstname:'',
			lastname:'',
			email:'',
			phoneno:'',
			address:'',
			grade:'',
			university:'',
			password:'',
			status:'',
			changepassword:'',
			confirm_password: '',
			 new_pass_type: 'password',
			confrim_pass_type: 'password',
            pass_show_hide_icon: 'shown',
            confirm_show_hide_icon: 'shown',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			disablepasssword:true,
			selectedDomainOption:'',
			selectedDomainvalue:'',
			maxCharacterLimit : 10,
			selectedInstituteOption:"",
			selectedInstituteValue:0,
			student_for:'',
			selectedClassOption: [],
			selectedClassvalue:'',
		};
		Geocode.setApiKey("AIzaSyBHmcBwYlcEtbcBeW3NaZtZw9Yuqtepmuc");
		var qs = require('qs');
		axios.get(apiUrl+"student/listdetail?id="+userid).then(res => {
			if(res.data.status == 'success'){
				const formdata = res.data.studentlist;
			if(formdata.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

			}
			this.setState({username:formdata.username});
						this.setState({firstname:formdata.firstname});
						this.setState({lastname:formdata.lastname});
						this.setState({email:formdata.email});
						this.setState({phoneno:formdata.mobile});
						this.setState({address:formdata.address});
						this.setState({student_for:formdata.student_for});
						// this.setState({grade:formdata.grade});
						// this.setState({university:formdata.university});						
						this.setState({userid: formdata.id});

						if(res.data.studentclasslist){
							this.setState({selectedClassOption:res.data.studentclasslist});
						}

						var postObject = {
							id: res.data.studentlist.domain_id,			
						};
				
						axios.post(apiUrl+"student/domainlist",qs.stringify(postObject)).then(res => {
							if(res.data.status == "success"){					
								let domaindata = res.data.domainlist;
								this.setState({selectedDomainOption:{value: domaindata[0]['domain_id'], label: domaindata[0]['domain_name']}});					
								this.setState({selectedDomainvalue:domaindata[0]['domain_id']});					
							}
						});

						var postObject = {
							id: formdata.institute,			
						};
		
						axios.post(apiUrl+"student/institutedetail",qs.stringify(postObject)).then(res => {
							if(res.data.status == "success"){					
								let institutedetail = res.data.institutedetail;
								this.setState({selectedInstituteOption:{value: institutedetail['id'], label: institutedetail['institute']}});	
								this.setState({selectedInstituteValue:  institutedetail['id']})				
							}
						});
			}
			
		}); 
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.new_pass_show_hide = this.new_pass_show_hide.bind(this);
       this.confim_pass_show_hide = this.confim_pass_show_hide.bind(this);
	   this.handleChange = this.handleChange.bind(this);
	   
    }

   handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });

		const google = window.google;
		const callfunc = this;

		if(name == 'address'){

			var input = document.getElementById('address');
			var autocomplete = new google.maps.places.Autocomplete(input);
			autocomplete.addListener('place_changed',function() {
		   // document.getElementById("location-error").style.display = 'none';
			var place = autocomplete.getPlace();
			var locationAddress = place.formatted_address;
			
			callfunc.setState({address: locationAddress})
			callfunc.getgoecoder(locationAddress,input.name);
			});		
	     }
     
    }

	getgoecoder(input, name){

		$('#address').val('');
			
		if(name == 'address'){ 
			Geocode.fromAddress(input).then(
			  response => {
				console.log(response,'response')
				const { lat, lng } = response.results[0].geometry.location;				
				this.setState({
					from_long : lng, 
					from_lat: lat,
					address: response.results[0].formatted_address
				});	
				
				/* document.getElementById('address').value = response.results[0].formatted_address;
				$('#address').val(response.results[0].formatted_address) */;				  
			
			  },
			  error => {
				console.error(error);
			  }
			);

			
		}

	}

	handleChange = (r,selOption) => {       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'institute'){
			this.setState({selectedClassOption:[]})
			this.setState({selectedClassvalue:""});
			this.setState({selectedInstituteOption:selOption})
			this.setState({  selectedInstituteValue : selOption.value});
		}else if(r == 'class'){			
			let selClass = [];
			let selClassValue = [];
			selOption.map(item => {
				selClassValue.push(item.value);
				selClass.push({ label: item.label, value: item.value });
			});
			
			this.setState({selectedClassOption:selClass})
			this.setState({  selectedClassvalue : selClassValue});
		}
 	};

	classlist = () => {
		var qs = require('qs');
		var postobject = {
			id: this.state.selectedInstituteValue
		};
		
		let classlists = [];
		axios.post(apiUrl+"classes/classeslist",qs.stringify(postobject)).then(res => {        
			if(res.data.status === "success"){
				let i=0;
				let classlist = res.data.classlist;           
				
				for(i; i<classlist.length; i++){
					
					let sname = classlist[i]['name'];
					classlists[i] = { value: classlist[i]['id'], label: sname };
				}
				
			}       
		});
		return classlists;
	}

	componentDidMount() {
		document.title = PageTitle('Student Edit');
		if(localStorage.getItem('admin_id') === null){
		this.props.history.push('/');
		}
    }

	new_pass_show_hide = () => {
    this.setState({
         new_pass_type: this.state.new_pass_type === 'input' ? 'password' : 'input',
         pass_show_hide_icon: this.state.new_pass_type === 'input' ? 'shown' : 'hiden'
        });
    }
    
    confim_pass_show_hide = () => {
    this.setState({
         confrim_pass_type: this.state.confrim_pass_type === 'input' ? 'password' : 'input',
         confirm_show_hide_icon: this.state.confrim_pass_type === 'input' ? 'shown' : 'hiden'
        });
    }
	
	
 handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				var qs = require('qs');
				const formPayload = this.state;
			    var status, institute, classs = '';
				var classes = [];
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
					status =formPayload.selectedOption.value;
				}else{
					status = formPayload.selectedvalue;
				}

				if(formPayload.selectedInstituteValue === '' && formPayload.selectedInstituteValue!== 0){
					institute =formPayload.selectedInstituteOption.value;
				}else{
					institute = formPayload.selectedInstituteValue;
				}

				if(formPayload.selectedClassvalue !== '' && formPayload.selectedClassvalue!== 0){
					classes = formPayload.selectedClassvalue;
				}

				var postObject = {
			        admin_id : localStorage.getItem("admin_id"),
					userid       : formPayload.userid,
					domain_id       : formPayload.selectedDomainvalue,
					username     : formPayload.username,
					firstname    : formPayload.firstname,
					lastname     : formPayload.lastname,
					email        : formPayload.email,
					phoneno      : formPayload.phoneno,
					address      : formPayload.address,
					student_for  : formPayload.student_for,	
					institute    : institute,	
					class		: classes,
					changepassword:formPayload.changepassword, 
					status       :  status,
				};
				axios.post(apiUrl+"student/edit",qs.stringify(postObject)).then(res => {
					
					if(res.data.status === "success"){
						this.setState({ Loading: false });

						const formpayload = res.data.studentlist;
						
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');


								setTimeout(
								function() {
									$('.success_message').html('');
									//this.props.navigate('/student');
								}
								.bind(this),
								3000
								);
					} else {
						this.setState({ Loading: false });
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
							setTimeout(
							function() {
								$('.success_message').html('');
							}
							.bind(this),
							3000
							);
					}
				});
			}
	}

	validateForm() {
		const {username,firstname, lastname, email, phoneno, changepassword, selectedClassOption, confirm_password,selectedDomainvalue,maxCharacterLimit,address,student_for, selectedInstituteOption} = this.state;
      	//let formIsValid = true;
		  const nameRegex = /^[A-Za-z\s]+$/;

		let errors = 0;
		if (!username) {
			
			errors++;
			$('.errorusername').html('<span class="errorspan">Please fill the field</span>');
		}else if(username){
			
			$('.errorusername').html('');
		}
		

		
		if (!firstname) {
			errors++;
			$('.errorfirstname').html('<span class="errorspan">Please fill the field</span>');
		}else if(firstname){
			if (!nameRegex.test(firstname)) {
				errors++;
			$('.errorfirstname').html('<span class="errorspan">Please enter the valid first name</span>');
			}else{
				$('.errorfirstname').html('');
			}
			
		}

		 if(lastname){
			if (!nameRegex.test(lastname)) {
				errors++;
			$('.errorlastname').html('<span class="errorspan">Please enter the valid last name</span>');
			}else{
				$('.errorlastname').html('');
			}
			
		}
		if (!email) {
			errors++;
			
			$('.erroremail').html('<span class="errorspan">Email is required</span>');
			}else if(email){
			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
			if (reg.test(email)) 
			{
			  $('.erroremail').html('');
			}else{
			  errors++;
			  
			$('.erroremail').html('<span class="errorspan">Please enter valid email address</span>');
			}
			  
			
			}
			if (!selectedDomainvalue) {
				errors++;
				$('.errorassign_domain').html('<span class="errorspan">Please select the field</span>');
		   }else if(selectedDomainvalue){
				$('.errorassign_domain').html('');
			}

		if (!phoneno) {
			errors++;
			
			$('.errorphoneno').html('<span class="errorspan">Contact is required</span>');
		  }else if(phoneno){	
			 var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
			 var indiapattern =/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
				if (pattern.test(phoneno)) {
				$('.errorphoneno').html('');
				}else if(indiapattern.test(phoneno)){
				$('.errorphoneno').html('');
				}else{
					 errors++;
				
					 $('.errorphoneno').html('<span class="errorspan">Please enter valid contact</span>');
				   }
				}


			if (!address) {
				errors++;
				$('.erroraddress').html('<span class="errorspan">Please fill the field</span>');
			}else if(address){					
				$('.erroraddress').html('');								
			}

			if(student_for == "institute"){
				if (!selectedInstituteOption) {			
					errors++;
					$('.errorinstitute').html('<span class="errorspan">Please select any institute</span>');
				}else{
					
					$('.errorinstitute').html('');
				}

				if(selectedClassOption.length === 0){
					errors++;
					$('.errorclass').html('<span class="errorspan">Please select atleast one class</span>');
				}else{
					
					$('.errorclass').html('');
				}
			}

		if(changepassword !=''){
			// if (changepassword.match(/[a-z]/g) && changepassword.match( 
            //         /[A-Z]/g) && changepassword.match( 
            //         /[0-9]/g) && changepassword.match( 
            //         /[^a-zA-Z\d]/g) && changepassword.length >= 8){
		 	// 			$('.errorpassword').html('');
			// }else{
			// 	errors++;
			// 	$('.errorpassword').html('<span class="errorspan">Min 8 characters with special,digit,lower and upper case like Greeks@12</span>');
			// }
		}
		/*
		if(confirm_password !=''){
		 if (confirm_password.match(/[a-z]/g) && confirm_password.match( 
                    /[A-Z]/g) && confirm_password.match( 
                    /[0-9]/g) && confirm_password.match( 
                    /[^a-zA-Z\d]/g) && confirm_password.length >= 8){
		 				$('.errorchangepaswd').html('');
		 }else{
		 	errors++;
			$('.errorchangepaswd').html('<span class="errorspan">Min 8 characters with special,digit,lower and upper case like Greeks@12</span>');
		 }
		 
		if(changepassword !== confirm_password){
          	errors++;
            $('.errorchangepaswd').html('<span class="errorspan">Confirm Password does not match</span>');
        }
		
		}*/
		


		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

		/*this.setState({
			errors: errors
		});
		return formIsValid;*/
    }

    componentWillReceiveProps(Props){
    	   if(Props.userdetails !== this.props.userdetails){
    		if(Object.keys(Props.userdetails).length > 0){
				this.setState({Loading:false});
					//console.log(Props.carlist);
					if(Props.userdetails[0].status === "success"){

						const formdata = Props.userdetails[0].studentlist;
						
						if(formdata.status === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

						}
						this.setState({username:formdata.username});
						this.setState({firstname:formdata.firstname});
						this.setState({lastname:formdata.lastname});
						this.setState({email:formdata.email});
						this.setState({phoneno:formdata.mobileno});
						this.setState({address:formdata.address});
						// this.setState({grade:formdata.grade});
						// this.setState({university:formdata.university});						
						this.setState({userid: formdata.id});
					   
					}
    		}
    	}

	
         if(Props.useredit !== this.props.useredit){
    		if(Object.keys(Props.useredit).length > 0){
    					this.setState({ Loading: false });

				if(Props.useredit[0].status === "success"){

    			const formdata = Props.useredit[0].studentlist;
				console.log(formdata);
				if(formdata.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
				}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

				}
			    this.setState({username:formdata.username});
				this.setState({firstname:formdata.firstname});
				this.setState({lastname:formdata.lastname});
				this.setState({email:formdata.email});
				this.setState({phoneno:formdata.mobileno});
				this.setState({userid: formdata.id});
				this.setState({address:formdata.address});
				// this.setState({grade:formdata.grade});
				// this.setState({university:formdata.university});
				
                $('.success_message').html('<div class="status_sucess"><h3>'+ Props.useredit[0].message+'</h3></div>');
                	scrollToTop();
    				setTimeout(
						function() {
							//$('.success_message').html(this.props.history.push('/student'));
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    			}else{
    				 $('.success_message').html('<div class="status_sucess"><h3>'+ Props.useredit[0].message+'</h3></div>');
                	scrollToTop();
    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    			}
    		}
    	}   
      }

	  handledomainChange = selectedDomainOption => {
		
		this.setState({selectedDomainOption:selectedDomainOption})
		this.setState({  selectedDomainvalue : selectedDomainOption.value});
	
}


	
  render() {

  	const {selectedOption,selectedInstituteOption,selectedClassOption} = this.state;

    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="student" />  	
	<div className="content">	
		<div className="content-wrapper">
        <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="add" href='/student'>Back</a> 
			</div>
			<div className="title">
				<h4>Edit Details</h4>
				
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data" >
			<div className="form-row">
			<div className="form-left">
		    	<div className="form-group">
					<label>User Name<span class="required" style={{ color: "red" }} >*</span></label>
				    <input type="text" name="username" onChange={this.handleInputChange} className="form-control" value={this.state.username} disabled="true"/>
					<div className="errorusername"></div>
				</div>
				<div className="form-group">
					<label>Last Name:</label>
				    <input type="text" name="lastname" onChange={this.handleInputChange} className="form-control" value={this.state.lastname} />
					<div className="errorlastname"></div>
				</div>
				<div className="form-group">
					<label>Contact<span class="required" style={{ color: "red" }} >*</span></label>
				    <input type="text" name="phoneno" onChange={this.handleInputChange} className="form-control" value={this.state.phoneno} />
					<div className="errorphoneno"></div>
				</div>

				<div className="form-group">					
						<label>Type<span class="required" style={{ color: "red" }} >*</span></label> 
						<div>
						{(this.state.student_for=='Institute') ? <span><input onChange={this.handleInputChange} type="radio" name="student_for" checked={this.state.student_for=='Institute'?'checked':''} value="Institute" /> Institute</span> : ''} &nbsp;
						{(this.state.student_for=='Other') ? <span><input onChange={this.handleInputChange} type="radio" name="student_for" checked={this.state.student_for=='Other'?'checked':''} value="Other" /> Other</span> : ''}
						</div>					
					</div>

					{this.state.student_for == "Institute" &&
					<div className="form-group">					
						<label>Institute<span class="required" style={{ color: "red" }} >*</span></label>
							<Select 
							value={selectedInstituteOption?selectedInstituteOption:""}
								options={lang.common.institute_option} 
								onChange={this.handleChange.bind(this, 'institute')}
								/>
								<div className='errorinstitute'></div>
					</div> 
					}

					{this.state.student_for == "Institute" && selectedInstituteOption != "" &&
					<div className="form-group">					
						<label>Class<span class="required" style={{ color: "red" }} >*</span></label>
							<Select 
							value={selectedClassOption?selectedClassOption:""}
								options={this.classlist()} 
								onChange={this.handleChange.bind(this, 'class')}
								isSearchable={true}
								isMulti
								/>
								<div className='errorclass'></div>
					</div>
  					}
				  
				
				</div>
			<div className="form-right">
				<div className="form-group">
					<label>First Name<span class="required" style={{ color: "red" }} >*</span></label>
				    <input type="text" name="firstname" onChange={this.handleInputChange} className="form-control" value={this.state.firstname} />
					<div className="errorfirstname"></div>
				</div>
				<div className="form-group">
					<label>Email<span class="required" style={{ color: "red" }} >*</span></label>
						<input type="text" name="email" onChange={this.handleInputChange} className="form-control" value={this.state.email} />
					<div className="erroremail"></div>
				</div>
				
				<div className="form-group">
					<label>Address<span class="required" style={{ color: "red" }} >*</span></label>
					<input type="text" name="address" onChange={this.handleInputChange} className="form-control" id="address"  value={this.state.address} />
					<div className="erroraddress"></div>
				</div>

				<div className="form-group eye-pad">
                    <label>Password</label>
                    <input type={this.state.new_pass_type}  name="changepassword" placeholder="Enter new password" className="form-control" value={this.state.changepassword} onChange={this.handleInputChange.bind(this)}/>
                    <span toggle="#password-field" className={this.state.pass_show_hide_icon} onClick={this.new_pass_show_hide}><i className="ft-eye" aria-hidden="true"></i></span>
                 </div>
                  <div className="errorpassword"></div>

					<div className="default-font">
					<div className="form-group">					
						<label>Status<span class="required" style={{ color: "red" }} >*</span></label>
							<Select 
							value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
								options={lang.common.status_option} 
								onChange={this.handleChange.bind(this, 'status')}
								/>
					</div>
					</div>

				{/* <div className="form-group eye-pad">
                    <label>Confirm Password<span class="required" style={{ color: "red" }} >*</span></label>
                    <input type={this.state.confrim_pass_type} name="confirm_password" id="confirm_password" placeholder="Enter confirm password" className="form-control" value={this.state.confirm_password} onChange={this.handleInputChange.bind(this)}/>
                    <span toggle="#password-field" className={this.state.confirm_show_hide_icon} onClick={this.confim_pass_show_hide}><i className="ft-eye" aria-hidden="true"></i></span>
                  </div>
                   <div className="errorchangepaswd"></div> */}

				   {/* <div className="form-group">
						<label>Grade<span class="required" style={{ color: "red" }} >*</span></label>
						<input type="text" name="grade" onChange={this.handleInputChange} className="form-control" value={this.state.grade} autoComplete="off" />
						<div className="errorgrade"></div>
					</div> */}

					

				</div>
			</div>		

			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                        <span className="load-data"></span> 
                                        }Submit
                   </button>
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}



export default withRouter(Edit);